import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

// This probaly needs to be changed in the schema registry. By adding a new type for the list of line items.
// and to avoid doing that here.
export const LineItemListSchema = order.fulfillmentService.versions.v1.schemas.GET_LINE_ITEMS_RESPONSE_SCHEMA.array();

export type LineItem = z.infer<typeof order.fulfillmentService.versions.v1.schemas.GET_LINE_ITEMS_RESPONSE_SCHEMA>;

/**
 * validation schema for response payload
 */
export const GetLineItemListResponseSchema =
    order.fulfillmentService.versions.v1.schemas.GET_LINE_ITEMS_RESPONSE_SCHEMA;

export type GetLineItemListResponse = z.infer<typeof GetLineItemListResponseSchema>;
